import { h, JSX } from 'preact';
import { memo } from 'preact/compat';
import * as keyboardEventHelpers from 'widget_main/globals/keyboardEvents';
import styles from './checkbox.scss';

interface CheckboxProps {
  name: string;
  ariaLabel?: string | JSX.Element;
  onClick: (checked: boolean, value?: string) => unknown;
  checked?: boolean;
  value?: string;
  id?: string;
  label?: string | JSX.Element;
  className?: string;
  disabled?: boolean;
}

const Checkbox = ({
  id,
  name,
  ariaLabel,
  onClick,
  checked,
  value,
  label,
  className,
  disabled,
}: CheckboxProps) => {
  const handleClick = (e) => {
    e.stopPropagation();
    onClick(!checked, value);
  };

  const handleKeyPress = (e: KeyboardEvent) => {
    if (keyboardEventHelpers.isEnterKey(e)) {
      e.preventDefault();
      e.stopPropagation();

      handleClick(e);
    }
  };

  return (
    <div
      role="checkbox"
      tabIndex={0}
      className={styles.container}
      onClick={handleClick}
      onKeyPress={handleKeyPress}
      aria-checked={checked}
    >
      <input
        type="checkbox"
        id={id || name}
        name={name}
        aria-label={
          (ariaLabel ||
            name) as JSX.InputHTMLAttributes<HTMLInputElement>['aria-label']
        }
        class={className}
        checked={checked}
        disabled={disabled}
        onClick={handleClick}
      />
      <label className={styles.label}>{label}</label>
    </div>
  );
};

export default memo(Checkbox);
